module.exports = __webpack_public_path__ + "static/media/icondfenhong.5a7d6a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icondfenhong.png
// module id = 2168
// module chunks = 0